import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function create(data) {
  const response = await http
    .postData("/monitoring-harian-nicu", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id: number, data) {
  const response = await http
    .putData(`/monitoring-harian-nicu/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/monitoring-harian-nicu/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/monitoring-harian-nicu/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getByRegister(registerId: string | number) {
  const response = await http
    .getData(`/register/${registerId}/monitoring-harian-nicu`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getByDate(registerId: string | number, tanggal: string) {
  const response = await http
    .getData(`/register/${registerId}/monitoring-harian-nicu/tanggal/${tanggal}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function carryForward(registerId: string | number, data) {
  const response = await http
    .postData(`/register/${registerId}/monitoring-harian-nicu/carry-forward`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function verifyDpjp(id: number) {
  const response = await http
    .postData(`/monitoring-harian-nicu/${id}/verify-dpjp`, {})
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function storeObservasi(monitoringId: number, data) {
  const response = await http
    .postData(`/monitoring-harian-nicu/${monitoringId}/observasi`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateObservasi(obsId: number, data) {
  const response = await http
    .putData(`/monitoring-harian-nicu-observasi/${obsId}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteObservasi(obsId: number) {
  const response = await http
    .deleteData(`/monitoring-harian-nicu-observasi/${obsId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function printPdf(id: number) {
  window.open(`${http.getAPI()}/monitoring-harian-nicu/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  find,
  destroy,
  getByRegister,
  getByDate,
  carryForward,
  verifyDpjp,
  storeObservasi,
  updateObservasi,
  deleteObservasi,
  printPdf
};
